<div class="mat-dialog-custom">
  <mat-dialog-content>
    <div class="header-dialog-custom">
      <button class="btn btn-sm btn-close" mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="body-dialog-custom">
      <div class="calendar-header mb-8">
        <div class="top-left">
          <button class="btn btn-today" (click)="onClickToday()">
            {{ 'CALENDAR_COMMON.TODAY_BTN' | translate }}
          </button>
        </div>
        <div class="txt-right">
          <button
            class="btn navigate-btn"
            (click)="changeYear('previous', isDisableDays)"
            [disabled]="!isDateInputView"
            [ngClass]="isDisableDays ? 'th-not-allowed' : ''">
            <mat-icon svgIcon="calendar_previous" aria-hidden="false"></mat-icon>
          </button>
        </div>
        <div>
          <div class="mar-bot">{{ yearNormal }}年</div>
        </div>
        <div class="txt-left">
          <button
            class="btn navigate-btn"
            (click)="changeYear('next', isDisableDays)"
            [disabled]="!isDateInputView"
            [ngClass]="isDisableDays ? 'th-not-allowed' : ''">
            <mat-icon svgIcon="calendar_next" aria-hidden="false"></mat-icon>
          </button>
        </div>
      </div>
      <div class="calendar-table" [ngClass]="isDateInputView ? 'table-date-view' : 'table-date-edit'">
        <div class="d-flex align-items-center justify-content-center">
          <div
            colspan="3"
            class="background-header-title right"
            [ngClass]="isDateInputView ? 'table-date-view' : 'op03'">
            <button
              class="btn navigate-btn"
              (click)="changeMonth('previous', isDisableDays)"
              [disabled]="!isDateInputView"
              [ngClass]="isDisableDays ? 'th-not-allowed' : ''">
              <mat-icon svgIcon="calendar_previous" aria-hidden="false"></mat-icon>
            </button>
          </div>
          <div
            colspan="1"
            class="background-header-title center font-weight-bolder"
            [ngClass]="isDateInputView ? 'table-date-view' : 'op03'">
            {{ month }}月
          </div>
          <div
            colspan="3"
            class="background-header-title left"
            [ngClass]="isDateInputView ? 'table-date-view' : 'op03'">
            <button
              class="btn navigate-btn"
              (click)="changeMonth('next', isDisableDays)"
              [disabled]="!isDateInputView"
              [ngClass]="isDisableDays ? 'th-not-allowed' : ''">
              <mat-icon svgIcon="calendar_next" aria-hidden="false"></mat-icon>
            </button>
          </div>
        </div>
        <table class="table table-bordered border-0 m-0">
          <thead class="thead-light">
            <tr>
              <th
                *ngFor="let dayTitle of dayOfWeekTitles"
                class="background-header-title"
                [ngClass]="isDateInputView ? 'table-date-view' : 'op03'">
                <span style="font-size: 14px">{{ dayTitle }}</span>
              </th>
            </tr>
          </thead>
          <tbody [ngClass]="isDateInputView ? 'table-date-view' : 'tbody-disable'">
            <tr *ngFor="let weekNumber of [].constructor(calendarConfig.MAX_WEEK_INDEX); let idxWeek = index">
              <td
                *ngFor="let dayNumber of [].constructor(calendarConfig.MAX_DAY_INDEX); let idxDay = index"
                (click)="daysInMonth[idxWeek * calendarConfig.MAX_DAY_INDEX + idxDay].isDisDay ? '' : clickCell(idxWeek, idxDay)"
                [ngClass]="{
                  'selected-cell-previous': daysInMonth[idxWeek * calendarConfig.MAX_DAY_INDEX + idxDay].isDisDay,
                  'selected-cell': selectedCell.day.getTime() === daysInMonth[idxWeek * calendarConfig.MAX_DAY_INDEX + idxDay].date.getTime(),
                  'has-data': daysInMonth[idxWeek * calendarConfig.MAX_DAY_INDEX + idxDay].hasData
                }"
                (dblclick)="daysInMonth[idxWeek * calendarConfig.MAX_DAY_INDEX + idxDay].isDisDay ? '' : onConfirm(idxWeek, idxDay)">
                <div>
                  <div hidden>{{ daysInMonth[idxWeek * calendarConfig.MAX_DAY_INDEX + idxDay] | json }} {{ selectedCell.day }}</div>
                  <span
                    [ngClass]="{
                      'tbody-disable': !isDateInputView,
                      'text-muted': !daysInMonth[idxWeek * calendarConfig.MAX_DAY_INDEX + idxDay].isInBound
                    }"
                    >{{ daysInMonth[idxWeek * calendarConfig.MAX_DAY_INDEX + idxDay].day }}</span
                  >
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="text-center mt-8">
        <button mat-flat-button class="btn-custom" (click)="onConfirmOK()" [disabled]="!isDateInputView">
          {{ 'CALENDAR_COMMON.OK_BTN' | translate }}
        </button>
      </div>
    </div>
  </mat-dialog-content>
</div>
